module.exports = __webpack_public_path__ + "img/m-csr.2d3eea21.jpg";